import { useTranslation } from "react-i18next";

import { useUserContext } from "@hooks/useUserContext";
import ApplicationIcon from "@icons/application.svg?react";
import DevicesIcon from "@icons/devices.svg?react";
import HomeIcon from "@icons/home.svg?react";
import OrganizationIcon from "@icons/organization.svg?react";
import PieReportIcon from "@icons/pie_report.svg?react";

import { Navigation } from "./Navigation";

export const MenuNavigation = () => {
  const { t } = useTranslation();
  const { user } = useUserContext();

  const navigationItems = [
    {
      icon: <HomeIcon />,
      label: t("home.nav_item.label"),
      url: "/",
      id: "home"
    },
    {
      icon: <OrganizationIcon />,
      label: t("organizations.nav_item.label"),
      url: "/organizations",
      id: "organizations"
    },
    {
      icon: <ApplicationIcon />,
      label: t("applications.nav_item.label"),
      url: "/applications",
      id: "applications"
    },
    {
      icon: <DevicesIcon />,
      label: t("resources.nav_item.label"),
      url: "/resources",
      id: "resources"
    }
  ];

  if (user.isSuperAdmin) {
    navigationItems.push({
      icon: <PieReportIcon />,
      label: t("audit-log.nav_item.label"),
      url: "/audit-log",
      id: "audit-log"
    });
  }

  return <Navigation items={navigationItems} />;
};
